export const STORAGE_KEYS = Object.freeze({
  workspaces: 'vectorloom:workspaces',
  activeWorkspace: 'vectorloom:active-workspace',
  settings: 'vectorloom:settings',
  /** Set to 'off' to boot with an empty workspace instead of the showcase (used by E2E). */
  seed: 'vectorloom:seed',
});

/** Bump when the persisted shape changes and add a migration in services/persistence. */
export const PERSISTENCE_SCHEMA_VERSION = 1;
